type Color = string

export const Colors = {
  BLUE: "#1a2747" as Color,
  GRAY: "#999999" as Color,
  ORANGE: "#f03e1b" as Color
}
